import revive_payload_client_YTGlmQWWT5 from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_PKIXU5KmsI from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_LIYcCMJD18 from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_SeG0EjL5Ec from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_Ib6KnAhqrq from "/home/circleci/wineaccess/nuxt-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_b2nUBUoYJ7 from "/home/circleci/wineaccess/nuxt-app/.nuxt/wineaccess/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_a7kQXwT7R5 from "/home/circleci/wineaccess/nuxt-app/.nuxt/wineaccess/nuxt-modernizr/plugin.js";
import plugin_01O9J0dmU6 from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import anchorscroll_plugin_nifcvYfr4Z from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt-anchorscroll/dist/runtime/anchorscroll-plugin.mjs";
import appUtilityPlugin_VBVDgjRoSx from "/home/circleci/wineaccess/nuxt-app/nuxt/modules/appUtility/runtime/appUtilityPlugin.ts";
import authPlugin_c9MCWklK42 from "/home/circleci/wineaccess/nuxt-app/nuxt/modules/djangoAuth/runtime/authPlugin.ts";
import sentry_client_config_0xPlqbiHZu from "/home/circleci/wineaccess/nuxt-app/.nuxt/wineaccess/sentry-client-config.mjs";
import formkitPlugin_hLN1JZ5YGF from "/home/circleci/wineaccess/nuxt-app/.nuxt/wineaccess/formkitPlugin.mjs";
import jquery_client_lJplQgNfHU from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/jquery.client.ts";
import intersection_observer_client_gBSX51sjRO from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/intersection-observer.client.js";
import axios_CfD7fZOyjI from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/axios.js";
import cookieMonster_1pmrnHfILf from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/cookieMonster.ts";
import vuexLoader_DTO7EPDJe2 from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/vuexLoader.ts";
import moment_vTtcXF2XoI from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/moment.ts";
import eventBus_gZqleRyv44 from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/eventBus.ts";
import v_calendar_GamRnoqMsp from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/v-calendar.js";
import newrelic_client_KvNwBAS0zE from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/newrelic.client.ts";
import recaptcha_tkd9GWohNJ from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/recaptcha.ts";
import vue_formulate_temC0MR4Xo from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/vue-formulate.js";
import vue_click_outside_Knaurh38j6 from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/vue-click-outside.js";
import linebreaks_4hsAFbCdnM from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/linebreaks.js";
import d3_6CqGt94b8T from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/d3.js";
import v_tooltip_7tD6DOvagO from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/v-tooltip.js";
import vue_toastification_mu5dZ7bRXz from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/vue-toastification.js";
import vue_scrollto_jEixPnkNUw from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/vue-scrollto.js";
import glide_Z3ERkKumPx from "/home/circleci/wineaccess/nuxt-app/nuxt/plugins/glide.js";
import access_analytics_client_jZJOXLaUXp from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/plugins/access-analytics.client.ts";
import facebookConnect_client_pPMauiMQKE from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/plugins/facebookConnect.client.js";
import routes_client_msK2Pxxta9 from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/plugins/routes.client.js";
import segment_client_UEbIPwLcQE from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/plugins/segment.client.js";
import sentry_client_H7JebPKzSG from "/home/circleci/wineaccess/nuxt-app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  navigation_repaint_client_PKIXU5KmsI,
  check_outdated_build_client_LIYcCMJD18,
  chunk_reload_client_SeG0EjL5Ec,
  plugin_vue3_Ib6KnAhqrq,
  components_plugin_b2nUBUoYJ7,
  prefetch_client_8FoqvPFTot,
  plugin_a7kQXwT7R5,
  plugin_01O9J0dmU6,
  anchorscroll_plugin_nifcvYfr4Z,
  appUtilityPlugin_VBVDgjRoSx,
  authPlugin_c9MCWklK42,
  sentry_client_config_0xPlqbiHZu,
  formkitPlugin_hLN1JZ5YGF,
  jquery_client_lJplQgNfHU,
  intersection_observer_client_gBSX51sjRO,
  axios_CfD7fZOyjI,
  cookieMonster_1pmrnHfILf,
  vuexLoader_DTO7EPDJe2,
  moment_vTtcXF2XoI,
  eventBus_gZqleRyv44,
  v_calendar_GamRnoqMsp,
  newrelic_client_KvNwBAS0zE,
  recaptcha_tkd9GWohNJ,
  vue_formulate_temC0MR4Xo,
  vue_click_outside_Knaurh38j6,
  linebreaks_4hsAFbCdnM,
  d3_6CqGt94b8T,
  v_tooltip_7tD6DOvagO,
  vue_toastification_mu5dZ7bRXz,
  vue_scrollto_jEixPnkNUw,
  glide_Z3ERkKumPx,
  access_analytics_client_jZJOXLaUXp,
  facebookConnect_client_pPMauiMQKE,
  routes_client_msK2Pxxta9,
  segment_client_UEbIPwLcQE,
  sentry_client_H7JebPKzSG
]